























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FormBase, FormInput, FormDate, FormSelect, FormTextarea, FormFile, FromJobToolzMultipleChoice, FromJobToolzExperience, FromJobToolzEducation, FromJobToolzYesNo, FormError, FormSubmit } from "./parts";
import { isMobile } from "mobile-device-detect";

interface JobToolzField {
    label: string;
    type: "text" | "email" | "image" | "file" | "education" | "experience" | "date" | "multiple_choice" | "yes_no";
    subType?: "text" | "textarea" | "email" | "image" | "file" | "education" | "experience" | "date" | "multiple_choice" | "yes_no";
    maxlength?: number;
    required: boolean;
    options?: string[];
    multiple?: boolean;
}

@Component({
    components: {
        FormBase,
        FormInput,
        FormDate,
        FormSelect,
        FormTextarea,
        FormError,
        FromJobToolzMultipleChoice,
        FromJobToolzExperience,
        FromJobToolzEducation,
        FromJobToolzYesNo,
        FormFile,
        FormSubmit
    }
})
export default class JobForm extends Vue {
    @Prop({ default: "" }) job!: string;
    @Prop({ required: true }) jobId!: string;
    @Prop({ required: false, default: false }) lazyload!: false;
    @Prop({ default: () => {} }) fields!: { [key: string]: JobToolzField };

    termsAccepted = false;

    loadingFormFields = false;

    localFields: { [key: string]: JobToolzField } = {};

    isMobile = isMobile;

    payload: { [key: string]: any } = {};

    errorResponse: ErrorResponse = {
        status: 0,
        errors: []
    };

    success_message = "";

    async mounted() {
        if (this.lazyload) {
            await this.lazyloadJobData();
        }
    }

    /**
     * Sort all fields but make sure the textarea, files and images fields are last in that order.
     */
    get sortedFields() {
        const fields = { ...this.localFields };
        const sortedFields: { [key: string]: JobToolzField } = {};

        Object.keys(fields)
            .sort((a, b) => {
                let fieldA = fields[a];
                let fieldB = fields[b];

                fieldA.subType = fieldA.type;
                if (fieldA.type === "text" && !fieldA.maxlength) {
                    fieldA.subType = "textarea";
                }

                fieldB.subType = fieldB.type;
                if (fieldB.type === "text" && !fieldB.maxlength) {
                    fieldB.subType = "textarea";
                }

                if (fieldA.subType === "image" && fieldB.subType !== "image") {
                    return 1;
                }

                if (fieldA.subType !== "image" && fieldB.subType === "image") {
                    return -1;
                }

                if (fieldA.subType === "file" && fieldB.subType !== "file") {
                    return 1;
                }

                if (fieldA.subType !== "file" && fieldB.subType === "file") {
                    return -1;
                }

                if (fieldA.subType === "textarea" && fieldB.subType !== "textarea") {
                    return 1;
                }

                if (fieldA.subType !== "textarea" && fieldB.subType === "textarea") {
                    return -1;
                }

                if (fieldA.subType === "education" && fieldB.subType !== "education") {
                    return 1;
                }

                if (fieldA.subType !== "education" && fieldB.subType === "education") {
                    return -1;
                }

                if (fieldA.subType === "experience" && fieldB.subType !== "experience") {
                    return 1;
                }

                if (fieldA.subType !== "experience" && fieldB.subType === "experience") {
                    return -1;
                }

                // if the label = "Waar ben je juist naar op zoek?", then the field should be first
                if (fieldA.label === "Waar ben je juist naar op zoek?") {
                    return -1;
                }

                return 0;
            })
            .forEach(key => {
                sortedFields[key] = fields[key];
            });

        return sortedFields;
    }

    private async lazyloadJobData() {
        this.loadingFormFields = true;
        // @ts-ignore
        const response = await axios.get(`/api/jobtoolz/jobs/${this.jobId}`);

        this.localFields = response.data.form_fields;

        this.setPayload();

        this.loadingFormFields = false;
    }

    private setPayload() {
        Object.keys(this.localFields).forEach((key: string) => {
            const field = this.localFields[key];
            if (["image", "file", "education", "experience"].includes(field.type)) {
                this.payload[key] = [];
            } else {
                this.payload[key] = "";
            }
        });
    }

    private getRules(field: JobToolzField) {
        const rules: string[] = [];

        if (field.required) {
            rules.push("required");
        }

        if (field.type === "email") {
            rules.push("email");
        }

        if (field.maxlength) {
            rules.push(`max:${field.maxlength}`);
        }

        return rules.join("|");
    }

    private submit(form: FormClass) {
        if (!this.termsAccepted) {
            return;
        }

        this.success_message = "";
        const formData = new FormData();
        formData.append("method", "_POST");
        formData.append("job_id", this.jobId);

        Object.keys(this.localFields).forEach((key: string) => {
            if (!this.payload[key]) {
                return;
            }

            const field = this.localFields[key];

            if (field.type === "image" || field.type === "file") {
                Object.values(this.payload[key]).forEach((file: any) => {
                    formData.append(`${key}[]`, file);
                });
            } else if (field.type === "yes_no") {
                formData.append(key, this.payload[key] === true ? "1" : "0");
            } else if (field.type === "education" || field.type === "experience") {
                Object.keys(this.payload[key]).forEach((arrayKey: any) => {
                    let object = this.payload[key][arrayKey];
                    Object.keys(object).forEach((objectKey: string) => {
                        formData.append(`${key}[${arrayKey}][${objectKey}]`, object[objectKey]);
                    });
                });
            } else {
                formData.append(key, this.payload[key]);
            }
        });

        // @ts-ignore
        axios
            .post(`/api/forms/jobtoolz-form`, formData)
            .then((response: any) => {
                if (response.data.success === false) {
                    this.errorResponse = {
                        status: 0,
                        errors: response.data.error.errors
                    };
                    return;
                }

                this.termsAccepted = false;

                this.setPayload();

                this.success_message = "Yep, die zit in onze mailbox. Bedankt voor je sollicitatie, en we contacteren je binnen de week!";

                this.errorResponse = {
                    status: 0,
                    errors: []
                };
            })
            .catch((e: { response: { data: ErrorResponse } }) => {
                this.errorResponse = e.response.data;
            })
            .finally(() => {
                form.reset();
            });
    }

    @Watch("fields", { immediate: true, deep: true })
    onFieldsChange(newFields: { [key: string]: JobToolzField }) {
        this.localFields = newFields;
    }
}
